module.exports = __webpack_public_path__ + "files/20cbbe0659a2b3b4bdbc9d7225cf38a8.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-120x120.png
// module id = 1248
// module chunks = 76